<script lang="ts">
    import {getCdnUrl} from "$lib/cdn";
    import ButtonGroup from "../Elements/ButtonGroup.svelte";
    import {extractUrlBySize} from "$lib/utils";

    export let section: Section;
    export let index: number;




</script>

<div class="bg-gray-900 py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl lg:mx-0">
            <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">{section.title}</h2>
            <p class="mt-6 text-lg leading-8 text-gray-300">
                {section.description}
            </p>
        </div>
        <ul role="list" class="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 xl:grid-cols-4">
            {#each section.blocks as block}
            <li>
                <img class="aspect-[14/13] w-full rounded-2xl object-cover" src={getCdnUrl(extractUrlBySize(block.image.data, 'medium'))} alt="">
                <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-white">{block.title}</h3>
                <p class="text-base leading-7 text-gray-300">{block.subTitle}</p>
                <p class="text-sm leading-6 text-gray-500">{block.description}</p>
            </li>
            {/each}
        </ul>
    </div>
</div>
